import { OfferSubCategory } from '../../common/enums.js';
import { fixedBroadbandConfig } from './FixedBroadbandConfigCoCo.js';
import { ProductOfferingsModalCoCo } from './ProductOfferingsModalCoCo.js';
import type { ModalDescriptionItem } from './ProductOfferingsModalCoCo.js';
import type { ProductOrderProps } from '../../common/types/shoppingBasketCoCo.js';
import type { ProductOfferingCoco } from '../../generated/api/productOfferingCoco.js';
import type { ProductOfferingsResponse } from '../../generated/api/productOfferingsResponse.js';

export interface ProductOfferModalPresenterCoCoProps {
  onOrder: ({ selectedProductOffers }: ProductOrderProps) => void;
  header: string;
  descriptionItems: ModalDescriptionItem[];
  image?: string;
  onCloseDialog: () => void;
  recurringCharge: number;
  oneTimeCharge: number;
  productOfferings: ProductOfferingsResponse;
  publicPages?: boolean;
  hasQuantity?: boolean;
  isChangeOffer?: boolean;
  commercialAddonProductOfferings?: ProductOfferingCoco[];
}

export const ProductOfferModalPresenterCoCo = (props: ProductOfferModalPresenterCoCoProps) => {
  const subcategory = props.productOfferings.productOfferingType?.subcategory;
  const isFixedBroadband =
    subcategory === OfferSubCategory.FIXED_BROADBAND ||
    subcategory === OfferSubCategory.FIXED_MOBILE_BROADBAND ||
    subcategory === OfferSubCategory.FIXED_BB_CABLE_MODEM ||
    subcategory === OfferSubCategory.FIXED_BB_OMAKAISTA;

  if (isFixedBroadband) {
    return <ProductOfferingsModalCoCo {...props} config={fixedBroadbandConfig} />;
  }

  return <ProductOfferingsModalCoCo {...props} />;
};
